export const SEARCH_TEMPLATE = 'SEARCH_TEMPLATE';
export const SEARCH_TEMPLATE_SUCCESS = 'SEARCH_TEMPLATE_SUCCESS';
export const SEARCH_TEMPLATE_FAILED = 'SEARCH_TEMPLATE_FAILED';
export const SAVE_TEMPLATE_SUCCESS = `SAVE_TEMPLATE_SUCCESS`;
export const SAVE_TEMPLATE_FAILED = `SAVE_TEMPLATE_FAILED`;
export const SAVE_TEMPLATE_ACCOMMODATION = `SAVE_TEMPLATE_ACCOMMODATION`;
export const DELETE_TEMPLATE_ACCOMMODATION = `DELETE_TEMPLATE_ACCOMMODATION`;
export const FETCH_TEMPLATE_PATTERNS = 'FETCH_TEMPLATE_PATTERNS';
export const FETCH_TEMPLATE_PATTERNS_SUCCESS = 'FETCH_TEMPLATE_PATTERNS_SUCCESS';
export const FETCH_CURRENT_TEMPLATE_PATTERN_SUCCESS = 'FETCH_CURRENT_TEMPLATE_PATTERN_SUCCESS';
export const FETCH_CURRENT_TEMPLATE_PATTERN = 'FETCH_CURRENT_TEMPLATE_PATTERN';
export const FETCH_CURRENT_TEMPLATE_PATTERNS = `FETCH_CURRENT_TEMPLATE_PATTERNS`;
export const FETCH_LOCATIONS = `FETCH_LOCATIONS`;
export const FETCH_OFFICES_SUCCESS = `FETCH_OFFICES_SUCCESS`;
export const FETCH_ODs = `FETCH_ODs`;
export const FETCH_EMPLOYEES_SUCCESS = `FETCH_EMPLOYEES_SUCCESS`;
export const FETCH_CURRENT_PATTERN_SUCCESS = `FETCH_CURRENT_PATTERN_SUCCESS`;
export const FETCH_CHANGE_RESULTS_SUCCESS = `FETCH_CHANGE_RESULTS_SUCCESS`;
export const FETCH_CHANGE_RESULTS = `FETCH_CHANGE_RESULTS`;

export const FETCH_RCD_LOCATION_NUMBER = 'FETCH_RCD_LOCATION_NUMBER';
export const FETCH_RCD_LOCATION_NUMBER_SUCCESS = 'FETCH_RCD_LOCATION_NUMBER_SUCCESS';

export const searchTemplate = (payload) => ({
  type: SEARCH_TEMPLATE,
  payload,
});

export const searchTemplateSuccess = (payload) => ({
  type: SEARCH_TEMPLATE_SUCCESS,
  payload,
});

export const searchTemplateFailed = (payload) => ({
  type: SEARCH_TEMPLATE_FAILED,
  payload,
});

export const SaveTemplateSuccess = (payload: any) => ({
  type: SAVE_TEMPLATE_SUCCESS,
  payload,
});

export const SaveTemplateFailed = (payload: any) => ({
  type: SAVE_TEMPLATE_FAILED,
  payload,
});

export const saveTemplateAccommodation = (payload: any) => ({
  type: SAVE_TEMPLATE_ACCOMMODATION,
  payload,
});

export const deleteTemplateAccommodation = (payload: any) => ({
  type: DELETE_TEMPLATE_ACCOMMODATION,
  payload,
});

export const fetchOfficesSuccess = (payload: any) => ({ type: FETCH_OFFICES_SUCCESS, payload });
export const fetchLocations = (payload?: any) => ({ type: FETCH_LOCATIONS });

export const fetchTemplatePatternsSuccess = (payload: any) => ({ type: FETCH_TEMPLATE_PATTERNS_SUCCESS, payload });
export const fetchTemplatePatterns = (payload?: any) => ({ type: FETCH_TEMPLATE_PATTERNS });

export const fetchCurrentTemplatePatternSuccess = (payload: any) => ({
  type: FETCH_CURRENT_TEMPLATE_PATTERN_SUCCESS,
  payload,
});

export const fetchCurrentTemplatePatterns = (payload: any) => ({
  type: FETCH_CURRENT_TEMPLATE_PATTERNS,
  payload,
});
export const fetchChangeResultsSuccess = (payload: any) => ({
  type: FETCH_CHANGE_RESULTS_SUCCESS,
  payload,
});

export const fetchChangeResults = (payload: any) => ({
  type: FETCH_CHANGE_RESULTS,
  payload,
});
export const fetchRCDByLocationNumberSuccess = (payload: any) => ({
  type: FETCH_RCD_LOCATION_NUMBER_SUCCESS,
  payload,
});

export const fetchRCDByLocationNumber = (payload: any) => ({
  type: FETCH_RCD_LOCATION_NUMBER,
  payload,
});

export const fetchODs = (payload?: any) => ({ type: FETCH_ODs });
export const fetchEmployeesSuccess = (payload: any) => ({ type: FETCH_EMPLOYEES_SUCCESS, payload });
export const fetchCurrentPatternSuccess = (payload: any) => ({
  type: FETCH_CURRENT_PATTERN_SUCCESS,
  payload,
});

export const resetSaveAccommodationSuccess = () => ({
  type: 'TEMPLATE_ACCOMODATION_RESET_SAVE_SUCCESS',
});
